import React from "react";

import Link from "../../../components/Link";
import Title from "../../../components/Title";
import SocialMedia from "./SocialMedia";

import style from "./style.module.css";

export default function MenuColumn({ title = "", item = [], socialMedia = [], userId = "" }) {
    return (
        <div className={style.footerColumn}>
            <div className={style.footerColumnInner}>
                <div className={style.menuWrap}>
                    {
                        title !== "" && (
                            <div className={style.footerMenuHeader}>
                                <Title className="footerMenuTitle" tag="p">{title}</Title>
                            </div>
                        )
                    }
                    {
                        item.length > 0 && (
                            <div className={style.footerMenuBody}>
                                {
                                    item.map((sitemapMenu, sitemapIndex) => {
                                        if ((sitemapMenu.show_in_public === "1" || userId !== "") && (sitemapMenu.url !== "" && sitemapMenu.label !== "")) {
                                            if (sitemapMenu.label === "Cookie Preferences") {
                                                return (
                                                    <Link
                                                        key={`sitemapIndex_${sitemapIndex}`}
                                                        onClick={() => window.displayPreferenceModal()}
                                                        className={style.footerMenuLink}
                                                    >
                                                        {sitemapMenu.label}
                                                    </Link>
                                                )
                                            }
                                            return (
                                                <Link
                                                    key={`sitemapIndex_${sitemapIndex}`}
                                                    to={sitemapMenu.url}
                                                    className={style.footerMenuLink}
                                                >
                                                    {sitemapMenu.label}
                                                </Link>
                                            )
                                        } else {
                                            return null;
                                        }
                                    })
                                }
                            </div>
                        )
                    }
                </div>
                {
                    socialMedia.length > 0 && (
                        <SocialMedia item={socialMedia} />
                    )
                }
            </div>
        </div>
    )
}